<template>
  <v-card height="100%">
    <v-data-table
      :headers="headers"
      :items="_clientSchools"
      sort-by="effectiveDate"
      sort-desc
      :item-class="formatCurrent"
    >
      <template v-if="canEdit" v-slot:[`top`]="{}">
        <v-row>
          <v-spacer></v-spacer>
          <client-school-form></client-school-form>
        </v-row>
      </template>
      <template v-slot:[`item.school`]="{ item }">
        <a
          @click="goToSchool(item.school.schoolId)"
          class="text-decoration-underline"
          >{{ item.school.schoolName }}</a
        >
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <client-school-form :clientSchool="item"></client-school-form>
        <v-btn
          v-if="isAdmin"
          x-small
          text
          color="primary"
          @click.stop="deleteClientSchool(item.clientSchoolId)"
          ><v-icon small>mdi-delete</v-icon></v-btn
        >
        <confirm-modal ref="confirm"></confirm-modal>
      </template>
      <template
        v-if="
          currentClientSchools.length > 0 &&
          currentClientSchools.length != clientSchools.length
        "
        v-slot:[`footer`]="{}"
      >
        <v-card-actions class="justify-center">
          <v-btn
            @click="showPrevious = !showPrevious"
            small
            text
            color="primary"
            >{{
              Boolean(showPrevious) ? "Hide Previous" : "Show Previous"
            }}</v-btn
          >
        </v-card-actions>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import ClientSchoolForm from "./client-school-form";
import ConfirmModal from "../../Shared/confirm-modal";

export default {
  components: { ClientSchoolForm, ConfirmModal },
  data() {
    return {
      headers: [
        { text: "School Name", value: "school" },
        { text: "Address", value: "school.streetAddress" },
        { text: "School Contact", value: "school.contact" },
        { text: "Phone", value: "school.phone" },
        { text: "Effective Date", value: "formattedEffectiveDate" },
        { text: "End Date", value: "formattedEndDate" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      showPrevious: false,
    };
  },
  computed: {
    isAdmin() {
      return this.$store.getters["securityModule/isAdmin"];
    },
    canEdit() {
      return (
        this.$store.getters["securityModule/isEIAdmin"] ||
        this.$store.getters["securityModule/isSEITAdmin"]
      );
    },
    clientSchools() {
      return (
        this.$store.state.clientModule.selectedClient.clientSchools || null
      );
    },
    _clientSchools() {
      // if on showPrevious || no current schools
      return Boolean(this.showPrevious) || this.currentClientSchools.length == 0
        ? // then show all
          this.clientSchools
        : // else show current only
          this.currentClientSchools;
    },
    currentClientSchools() {
      var today = new Date();
      return this.clientSchools.filter(
        (item) => item.endDate == null || new Date(item.endDate) > today
      );
    },
  },
  methods: {
    formatCurrent(item) {
      let today = new Date();
      if (item.effectiveDate <= today && item.endDate >= today) {
        return "elevation-3";
      }
    },
    goToSchool(schoolId) {
      this.$router.push({ name: "SchoolForm", params: { schoolId: schoolId } });
    },
    deleteClientSchool: async function (clientSchoolId) {
      if (
        await this.$refs.confirm.open(
          "Are you sure you want to REMOVE this registration?",
          "Note: This action cannot be undone.",
          "Delete"
        )
      ) {
        this.$store.commit("uxModule/setShowLoader", true);
        var message = await this.$store.dispatch(
          "clientModule/deleteClientSchool",
          clientSchoolId
        );
        if (message) {
          this.$store.commit("uxModule/setSnackbarMsg", message);
          this.$store.commit("uxModule/setShowSnackbar", true);
        }
        this.$store.commit("uxModule/setShowLoader", false);
      }
    },
  },
};
</script>
